import React from "react";
import { ScrollableComponentElement } from "scrollable-component";

const AllBankDetails = ({ allGymsData, setBankDetailsAvailable }) => {
  return (
    <scrollable-component className="my-content">
      {allGymsData?.map((bank, index) => (
        <div className="erpListBox" key={index}>
          <div className="iconAndLabel lsgbTransactonDateId">
            <p className="name">{bank?.gym_name || "N/A"}</p>
            <span className="transactionid">
              {bank?.account_number && bank?.account_number !== "null"
                ? bank.account_number
                : "-"}
            </span>
          </div>
          <button
            className="viewDetailsBtn"
            onClick={() =>
              setBankDetailsAvailable({
                bankDetailsModal: true,
                bankDetails: bank,
              })
            }
          >
            View details
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-right"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
          </button>
        </div>
      ))}
    </scrollable-component>
  );
};

export default AllBankDetails;
